import { type RecType } from '@/defs/rec'
import { formatFullNumber } from '@/utils/formatUtil'

import { StatCommonBox } from '../../StatCommon/StatCommonBox/StatCommonBox'
import { StatCommonFigure } from '../../StatCommon/StatCommonFigure/StatCommonFigure'
import { StatRecDeckTotalTooltip } from '../StatRecDeckTotalTooltip/StatRecDeckTotalTooltip'

type Props = {
  rec: RecType
  variant?: 'commander'
}

export const StatRecDeckTotalFull = ({ rec, variant }: Props) => (
  <StatCommonBox
    label='Decks'
    popover={rec.numDecks !== undefined && <StatRecDeckTotalTooltip rec={rec} variant={variant} />}
  >
    {rec.numDecks !== undefined && <StatCommonFigure>{formatFullNumber(rec.numDecks)}</StatCommonFigure>}
  </StatCommonBox>
)
